import React from "react";

import { DEFAULT_CARD_HEIGHT, TAG } from "config/constants";
import TagStreamWrapper from "stream/containers/TagStreamWrapper";
import Stream from "stream/containers/Stream";
import FullStoryCard from "cards/containers/FullStoryCard";
import PromoStreamCap from "stream/components/PromoStreamCap";
import Helmet from "react-helmet-async";

import image from "assets/img/refugee-crisis.png";
import ogImage from "assets/img/refugee-crisis-social.jpg";

export default function RefugeeCrisisTagStream() {
  return (
    <React.Fragment>
      <Helmet>
        <meta property="og:image" content={ogImage} />
      </Helmet>
      <TagStreamWrapper slug={TAG.REFUGEE_CRISIS.slug}>
        {({ streamParams }) => (
          <React.Fragment>
            <PromoStreamCap
              promo={{
                title: "The refugee crisis is the worst it's been since WWII.",
                content: (
                  <span>
                    Read our full report below and{" "}
                    <a
                      className="gtm-promo-stream-cap-content-link"
                      href="https://signup.axios.com/2019/am.html?source=axios&medium=referral&campaign=stream_cap_promo_link&page=axios"
                    >
                      sign up for Axios AM{" "}
                    </a>
                    to get deep dives into the biggest topics impacting the
                    future.
                  </span>
                ),
                contentForAnalytics:
                  "Read our full report below and sign up for Axios AM to get deep dives into the biggest topics impacting the future.",
                image: image,
              }}
            />
            <Stream
              {...streamParams}
              defaultCardHeight={DEFAULT_CARD_HEIGHT.FULL_STORY_CARD}
              contentComponent={FullStoryCard}
            />
          </React.Fragment>
        )}
      </TagStreamWrapper>
    </React.Fragment>
  );
}
